import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { Spinner } from './Spinner';
import { Button, buttonClass } from './ui/Button';

// The inline editor for one email-route override (#325), on the .input/.btn
// primitives. Pure presenter: the row owns the address/busy/error state and
// the save/cancel persistence. No visible label — the input is aria-labelled
// per category, so the `.field` column scaffolding stays out.

export function RouteAddressForm(props: {
  category: string;
  address: string;
  busy: boolean;
  error: string | null;
  onInput: (value: string) => void;
  onSubmit: (e: Event) => void;
  onCancel: () => void;
}): JSX.Element {
  return (
    <form class="email-route__form" onSubmit={props.onSubmit}>
      <input
        type="email"
        required
        class="input email-route__input"
        value={props.address}
        disabled={props.busy}
        placeholder={t('email_routes.address_placeholder')}
        aria-label={t('email_routes.address_label', { category: props.category })}
        onInput={(e) => props.onInput(e.currentTarget.value)}
      />
      <button type="submit" class={buttonClass({ size: 'sm' })} disabled={props.busy}>
        <Show when={props.busy} fallback={t('email_routes.save')}>
          <Spinner size="0.875rem" />
          {t('email_routes.saving')}
        </Show>
      </button>
      <Button variant="outline" size="sm" disabled={props.busy} onClick={props.onCancel}>
        {t('email_routes.cancel')}
      </Button>
      <Show when={props.error}>
        <span class="field__error" role="alert">
          {props.error}
        </span>
      </Show>
    </form>
  );
}
